import { AgxRow, AgxTypography } from '@urbanx/agx.ui-components2';
import { MenuTitles } from 'constants/menu';

interface BackButtonBreadCrumbsProps {
  selectedContract?: {
    contractName: string;
  };
  campaignId?: string;
  agencyId?: string;
  isAgencyDashboard?: boolean;
  primaryPageTitle: string;
  addressLineOne: string | null;
}

const BackButtonBreadCrumbs = ({
  selectedContract,
  campaignId,
  agencyId,
  isAgencyDashboard,
  primaryPageTitle,
  addressLineOne,
}: BackButtonBreadCrumbsProps) => {
  const agencyName = primaryPageTitle.trim();
  const streetAddress = addressLineOne?.trim();

  if (selectedContract) {
    const contractName = selectedContract.contractName.trim();

    if (!agencyName || !streetAddress || !contractName) return null;

    return (
      <AgxRow gap="spacing-md">
        <AgxTypography
          id={'selectedContractTitle'}
          type={'body_ui'}
          size={'small'}
          color="var(--text-primary)"
        >
          {agencyName}
        </AgxTypography>
        <AgxTypography
          id={'selectedContractCampaign'}
          type={'body_ui'}
          size={'small'}
          color="var(--text-secondary)"
        >
          {`/ ${MenuTitles.CAMPAIGNS} `}
        </AgxTypography>
        <AgxTypography
          id={'selectedContractTitle'}
          type={'body_ui'}
          size={'small'}
          color="var(--text-secondary)"
        >
          {`/ ${streetAddress}`}
        </AgxTypography>
        <AgxTypography
          id={'selectedContractTitle'}
          type={'body_ui'}
          size={'small'}
          color="var(--text-secondary)"
        >
          {`/ ${contractName}`}
        </AgxTypography>
      </AgxRow>
    );
  }
  if (campaignId) {
    if (!agencyName || !streetAddress) return null;

    return (
      <AgxRow gap="spacing-md">
        <AgxTypography
          id={'selectedCampaignTitle'}
          type={'body_ui'}
          size={'small'}
          color="var(--text-primary)"
        >
          {agencyName}
        </AgxTypography>
        <AgxTypography
          id={'selectedCampaignCampaign'}
          type={'body_ui'}
          size={'small'}
          color="var(--text-secondary)"
        >
          {`/ ${MenuTitles.CAMPAIGNS} `}
        </AgxTypography>
        <AgxTypography
          id={'selectedCampaignAddress'}
          type={'body_ui'}
          size={'small'}
          color="var(--text-secondary)"
        >
          {`/ ${streetAddress}`}
        </AgxTypography>
      </AgxRow>
    );
  }
  if (isAgencyDashboard) {
    return (
      <AgxRow gap="spacing-md">
        <AgxTypography
          id={'agencyDashboardTitle'}
          type={'body_ui'}
          size={'small'}
          color="var(--text-primary)"
        >
          Partner
        </AgxTypography>
      </AgxRow>
    );
  }
  if (agencyId) {
    return (
      <AgxRow gap="spacing-md">
        <AgxTypography
          id={'agencyIdTitle'}
          type={'body_ui'}
          size={'small'}
          color="var(--text-primary)"
        >
          Agencies
        </AgxTypography>
      </AgxRow>
    );
  }

  return null;
};

export default BackButtonBreadCrumbs;
